import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup } from './StyledComponents';

const ClassificationInputs = ({
  inputs,
  classification,
  decideFormElement,
}) => (
  <>
    {Object.entries(inputs).map(([inputKey, inputValue]) => (
      <FormGroup key={`FormGroup-${classification}-${inputKey}`}>
        {decideFormElement(inputValue)}
      </FormGroup>
    ))}
  </>
);

ClassificationInputs.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  inputs: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  classification: PropTypes.string.isRequired,
  decideFormElement: PropTypes.func.isRequired,
};

export default ClassificationInputs;
